export const LAYOUT_CANVAS_MOUNT_PREFETCH_PX = 720;
export const LAYOUT_CANVAS_INITIAL_MOUNT_LIMIT = 12;
export interface LayoutCanvasMountingItem { id: string; layout: { x: number; y: number } }
export function initialLayoutCanvasMountedIds(items: readonly LayoutCanvasMountingItem[]): string[] {
  return [...items].sort((a, b) => a.layout.y - b.layout.y || a.layout.x - b.layout.x).slice(0, LAYOUT_CANVAS_INITIAL_MOUNT_LIMIT).map(item => item.id);
}
export function layoutCanvasRetainedMountLimit(total: number, visible: number, initial: number): number {
  if (![total, visible, initial].every(Number.isFinite)) throw new TypeError('Invalid layout mount count.');
  total = Math.max(0, Math.floor(total)); if (!total) return 0;
  visible = Math.min(total, Math.max(0, Math.floor(visible))); initial = Math.min(total, Math.max(0, Math.floor(initial)));
  const cap = total >= 120 ? 24 : total >= 80 ? 32 : total >= 48 ? 40 : 48;
  const base = Math.max(initial, Math.min(visible, cap));
  const headroom = Math.max(8, Math.ceil(base * 0.75));
  return Math.min(total, Math.max(Math.min(total, 18), Math.min(cap, base + headroom)));
}
/** Visible order comes from the observer's insertion order, not DOM sorting. */
export function projectLayoutCanvasMounting(input: {
  items: readonly LayoutCanvasMountingItem[];
  visibleIds: readonly string[];
  retainedOrder: readonly string[];
  mode: 'edit' | 'run';
  selectedWidgetId?: string;
  draggingWidgetId?: string;
  resizingWidgetId?: string;
}): { retainedOrder: string[]; mountedIds: string[]; limit: number } {
  const valid = new Set(input.items.map(item => item.id));
  if (valid.size !== input.items.length) throw new TypeError('Layout widget IDs must be unique.');
  const visible = new Set(input.visibleIds.filter(id => valid.has(id)));
  const initial = initialLayoutCanvasMountedIds(input.items);
  const limit = layoutCanvasRetainedMountLimit(valid.size, visible.size, initial.length);
  if (input.mode === 'run') return { retainedOrder: [], mountedIds: [...visible], limit };
  const order = [...new Set(input.retainedOrder.filter(id => valid.has(id)))];
  if (!order.length) order.push(...initial);
  for (const id of [...visible, input.selectedWidgetId, input.draggingWidgetId, input.resizingWidgetId]) {
    if (!id || !valid.has(id)) continue;
    const index = order.indexOf(id); if (index >= 0) order.splice(index, 1); order.push(id);
  }
  // The legacy policy never evicts visible items, even if they exceed the soft limit.
  while (order.length > limit) { const index = order.findIndex(id => !visible.has(id)); if (index < 0) break; order.splice(index, 1); }
  return { retainedOrder: order, mountedIds: [...new Set([...order, ...visible])], limit };
}
